import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import CommonModal from 'components/elements/modals/CommonModal';

import './DowngradePlanModal.css';

const DowngradePlanModal = ({ open, onClose, onDowngrade }) => (
  <Translation>
    {(t) => (
      <CommonModal
        className="downgrade-plan-modal__component"
        open={open}
        onClose={onClose}
      >
        <div className="wrapper">
          <div className="title">
            {t("We're sorry to see you go ;(")}
          </div>
          <div className="text-content">
            <div>{t("Are you sure you want to downgrade account?")}</div>
            <div>{t("By unsibscribing from HeyLink.me PRO")}</div>
            <div>{t("you will lose access to all PRO features")}</div>
          </div>
          <div className="buttons-block">
            <div
              className="modal-button"
              onClick={onClose}
              role="button"
              tabIndex={-1}
            >
              <div>{t("I don't want")}</div>
              <div>{t("to downgrade")}</div>
            </div>

            <div
              className="modal-button"
              onClick={onDowngrade}
              role="button"
              tabIndex={-1}
            >
              <div>{t("Please downgrade me")}</div>
              <div>{t("from PRO to basic")}</div>
            </div>
          </div>
        </div>
      </CommonModal>
    )}
  </Translation>
);

DowngradePlanModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDowngrade: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

DowngradePlanModal.defaultProps = {
  open: null,
};

export default DowngradePlanModal;
